import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { http } from './http';

var SessionService = /*#__PURE__*/function () {
  function SessionService() {
    _classCallCheck(this, SessionService);
  }

  _createClass(SessionService, [{
    key: "createActivity",
    value: function () {
      var _createActivity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.post('/activity', payload);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function createActivity(_x) {
        return _createActivity.apply(this, arguments);
      }

      return createActivity;
    }()
  }, {
    key: "getActivities",
    value: function () {
      var _getActivities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.get("/activity/?serviceId=".concat(payload.serviceId, "&startsAt=").concat(payload.startsAt, "&endsAt=").concat(payload.endsAt));

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getActivities(_x2) {
        return _getActivities.apply(this, arguments);
      }

      return getActivities;
    }()
  }, {
    key: "deleteActivity",
    value: function () {
      var _deleteActivity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(activityId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http["delete"]("/activity/".concat(activityId));

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function deleteActivity(_x3) {
        return _deleteActivity.apply(this, arguments);
      }

      return deleteActivity;
    }()
  }, {
    key: "updateActivity",
    value: function () {
      var _updateActivity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(activityId, activity) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.put("/activity/".concat(activityId), activity);

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function updateActivity(_x4, _x5) {
        return _updateActivity.apply(this, arguments);
      }

      return updateActivity;
    }()
  }, {
    key: "createSession",
    value: function () {
      var _createSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return http.post("/session", payload);

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", result.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function createSession(_x6) {
        return _createSession.apply(this, arguments);
      }

      return createSession;
    }()
  }, {
    key: "getActivity",
    value: function () {
      var _getActivity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(activityId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return http.get("/activity/".concat(activityId));

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", result.data);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getActivity(_x7) {
        return _getActivity.apply(this, arguments);
      }

      return getActivity;
    }()
  }, {
    key: "getAllSessions",
    value: function () {
      var _getAllSessions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return http.get("/session/all");

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", result.data);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getAllSessions() {
        return _getAllSessions.apply(this, arguments);
      }

      return getAllSessions;
    }()
  }, {
    key: "getSession",
    value: function () {
      var _getSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(sessionId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return http.get("/session/".concat(sessionId));

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", result.data);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function getSession(_x8) {
        return _getSession.apply(this, arguments);
      }

      return getSession;
    }()
  }, {
    key: "getSessionAccess",
    value: function () {
      var _getSessionAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(sessionId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return http.get("/session/".concat(sessionId, "/access"));

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", result.data);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getSessionAccess(_x9) {
        return _getSessionAccess.apply(this, arguments);
      }

      return getSessionAccess;
    }()
  }, {
    key: "updateSession",
    value: function () {
      var _updateSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(providerServiceId, sessionId, session) {
        var result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return http.put("/provider-service/".concat(providerServiceId, "/sessions/").concat(sessionId), session);

              case 2:
                result = _context10.sent;
                return _context10.abrupt("return", result.data);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function updateSession(_x10, _x11, _x12) {
        return _updateSession.apply(this, arguments);
      }

      return updateSession;
    }()
  }, {
    key: "getUserSubscriptions",
    value: function () {
      var _getUserSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(userId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return http.get("subscriptions?userId=".concat(userId));

              case 2:
                result = _context11.sent;
                return _context11.abrupt("return", result.data);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function getUserSubscriptions(_x13) {
        return _getUserSubscriptions.apply(this, arguments);
      }

      return getUserSubscriptions;
    }()
  }, {
    key: "createSubscriptionOrder",
    value: function () {
      var _createSubscriptionOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return http.post("/plan/".concat(planId, "/orders"));

              case 2:
                result = _context12.sent;
                return _context12.abrupt("return", result.data);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function createSubscriptionOrder(_x14) {
        return _createSubscriptionOrder.apply(this, arguments);
      }

      return createSubscriptionOrder;
    }()
  }, {
    key: "getSubscriptionOrder",
    value: function () {
      var _getSubscriptionOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(planId, orderId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return http.post("/plan/".concat(planId, "/orders/").concat(orderId));

              case 2:
                result = _context13.sent;
                return _context13.abrupt("return", result.data);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function getSubscriptionOrder(_x15, _x16) {
        return _getSubscriptionOrder.apply(this, arguments);
      }

      return getSubscriptionOrder;
    }()
  }, {
    key: "subscribeToPlan",
    value: function () {
      var _subscribeToPlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return http.post("/plan/".concat(payload.planId, "/subscriptions"), payload);

              case 2:
                result = _context14.sent;
                return _context14.abrupt("return", result.data);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function subscribeToPlan(_x17) {
        return _subscribeToPlan.apply(this, arguments);
      }

      return subscribeToPlan;
    }()
  }, {
    key: "getSubscriptionById",
    value: function () {
      var _getSubscriptionById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(planId, subscriptionId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return http.get("/plan/".concat(planId, "/subscriptions/").concat(subscriptionId));

              case 2:
                result = _context15.sent;
                return _context15.abrupt("return", result.data);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function getSubscriptionById(_x18, _x19) {
        return _getSubscriptionById.apply(this, arguments);
      }

      return getSubscriptionById;
    }()
  }, {
    key: "updateSubscription",
    value: function () {
      var _updateSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
        var planId, id, result;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                planId = payload.planId, id = payload.id;
                _context16.next = 3;
                return http.put("/plan/".concat(planId, "/subscriptions/").concat(id), payload);

              case 3:
                result = _context16.sent;
                return _context16.abrupt("return", result.data);

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function updateSubscription(_x20) {
        return _updateSubscription.apply(this, arguments);
      }

      return updateSubscription;
    }()
  }, {
    key: "cancelSubscription",
    value: function () {
      var _cancelSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(planId, subscriptionId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return http.post("/plan/".concat(planId, "/subscriptions/").concat(subscriptionId, "/cancel"));

              case 2:
                result = _context17.sent;
                return _context17.abrupt("return", result.data);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function cancelSubscription(_x21, _x22) {
        return _cancelSubscription.apply(this, arguments);
      }

      return cancelSubscription;
    }()
  }, {
    key: "getUpcomingSessions",
    value: function () {
      var _getUpcomingSessions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(userId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return http.get("/session/".concat(userId, "/upcoming-sessions"));

              case 2:
                result = _context18.sent;
                return _context18.abrupt("return", result.data);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function getUpcomingSessions(_x23) {
        return _getUpcomingSessions.apply(this, arguments);
      }

      return getUpcomingSessions;
    }()
  }, {
    key: "addToGoogleCalendar",
    value: function () {
      var _addToGoogleCalendar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(sessionId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return http.post("/session/".concat(sessionId, "/add-to-google-calendar"));

              case 2:
                result = _context19.sent;
                return _context19.abrupt("return", result.data);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function addToGoogleCalendar(_x24) {
        return _addToGoogleCalendar.apply(this, arguments);
      }

      return addToGoogleCalendar;
    }()
  }]);

  return SessionService;
}();

var sessionService = new SessionService();
export default sessionService;